<nav class="navbar navbar-light bg-light navbar-expand-lg">
    <div class="container">
        <a class="navbar-brand" routerLink="/" routerLinkActive="active">
            <img src="/assets/brand_logo_icon.png" width="32" height="32">
        </a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div id="navbarCollapse" class="collapse navbar-collapse">
            <ul class="navbar-nav me-auto">
                <li class="nav-item">
                    <a class="nav-link" routerLink="/users" routerLinkActive="active">Users</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLink="/devices" routerLinkActive="active">Devices</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLink="/firmwares" routerLinkActive="active">Firmwares</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLink="/banners" routerLinkActive="active">Banners</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLink="/community" routerLinkActive="active">Community</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLink="/watchfaces" routerLinkActive="active">Watchfaces</a>
                </li>
                <!-- <li class="nav-item">
                    <a class="nav-link" routerLink="/challenges" routerLinkActive="active">Challenges</a>
                </li> -->
                <li class="nav-item">
                    <a class="nav-link" routerLink="/notifications" routerLinkActive="active">Notifications</a>
                </li>
            </ul>
            <button class="btn btn-secondary" (click)="logout()">
                <i class="fas fa-sign-out-alt"></i> Logout
            </button>
        </div>
    </div>
</nav>